export const DASHBOARD_ONBOARDING = [
  {
    pageName: 'Dashboard',
    name: 'dashboard.onboarding.title',
    description: 'dashboard.onboarding.subtitle',
    steps: [
      {
        description: 'dashboard.onboarding.step1',
        image: require('./images/tutorial_1/1.png')
      },
      {
        description: 'dashboard.onboarding.step2',
        image: require('./images/tutorial_1/2.png')
      },
      {
        description: 'dashboard.onboarding.step3',
        image: require('./images/tutorial_1/3.png')
      },
      {
        description: 'dashboard.onboarding.step4',
        image: require('./images/tutorial_1/4.png')
      },
      {
        description: 'dashboard.onboarding.step5',
        image: require('./images/tutorial_1/5.png')
      },
      {
        description: 'dashboard.onboarding.step6',
        image: require('./images/tutorial_1/6.png')
      },
      {
        description: 'dashboard.onboarding.step7',
        image: require('./images/tutorial_1/7.png')
      },
      {
        description: 'dashboard.onboarding.step8',
        image: require('./images/tutorial_1/8.png')
      }
    ]
  }
];
